<template>
  <div class="dimmed">
    <template v-if="flowData">
      <div class="popup__content">
        <div class="content">
          <h4 class="tit_uesr">
            {{ $t('funnel.funnelsItem.userBehavior') }}
          </h4>
          <span class="txt_pv">{{ $t('common.unit.label') }} : PV</span>
          <div class="funnels__flow--wrap">
            <div class="left__flow--wrap" :class="{ empty: !hasReferers }">
              <ul v-if="hasReferers" class="list_flow">
                <li v-for="(item , index) in referers" :key="index"
                  class="item" :class="item.cssClass">
                  <div class="bar--wrap">
                    <span class="bar_bg" :style="{ width: `${item.percentage}%` }"></span>
                  </div>
                  <div class="value_wrap">
                    <span class="flow_txt ellipsis">
                      <span v-if="item.stepData" :title="item.stepData.name">
                        <span class="txt_desc">
                          Step {{ item.stepData.step }}
                        </span>
                        {{ item.stepData.name }}
                      </span>
                      <span v-else :title="item.url">{{ item.url }}</span>
                    </span>
                    <span class="flow_num">{{ item.count | thousand }} ({{ item.percentage | fixed(1) }}%)</span>
                  </div>
                </li>
              </ul>
              <span v-else class="txt_info">
                <span class="icon--session"></span>
                <span class="text">{{ $t('common.noSession') }}</span>
              </span>
            </div>
            <div class="page__info--wrap">
              <strong class="page_tit">Step {{ flowData.funnel.step }}</strong>
              <span class="page_info ellipsis">{{ flowData.funnel.name }}</span>
              <span class="page_url ellipsis">{{ flowData.funnel.url }}</span>
              <span class="page_tag">{{ flowData.funnel.matchType | matchType }}</span>
            </div>
            <div class="right__flow--wrap" :class="{ empty: !hasConversions }">
              <ul v-if="hasConversions" class="list_flow">
                <li v-for="(item , index) in conversions" :key="index"
                  class="item" :class="item.cssClass">
                  <div class="bar--wrap">
                    <span class="bar_bg" :style="{ width: `${item.percentage}%` }"></span>
                  </div>
                  <div class="value_wrap">
                    <span class="flow_txt ellipsis">
                      <span v-if="item.stepData" :title="item.stepData.name">
                        <span class="txt_desc">
                          Step {{ item.stepData.step }}
                        </span>
                        {{ item.stepData.name }}
                      </span>
                      <span v-else :title="item.url">{{ item.url }}</span>
                    </span>
                    <span class="flow_num">{{ item.count | thousand }}
                      ({{ item.percentage | fixed(1) }}%)</span>
                  </div>
                </li>
                <li class="item item6">
                  <div class="value_wrap">
                    <span class="flow_txt">{{ $t('common.exit') }}</span>
                    <span class="flow_num">{{ flowData.dropped | thousand }}
                      ({{ droppedPercentage | fixed(1) }}%)</span>
                  </div>
                </li>
              </ul>
              <span v-else class="txt_info right">
                <span class="icon--session"></span>
                <span class="text">{{ $t('common.noSession') }}</span>
              </span>
            </div>
          </div>
        </div>
        <button class="btn__close" @click="$emit('onCloseClick')">
          <i class="icon icon--close-btn"></i>
        </button>
      </div>
    </template>
    <div v-if="deletedItems" class="popup__content popup__content3">
      <div class="content">
        <p class="txt_desc">
          <span class="icon icon--alert"></span>
          {{ $t('funnel.funnelLayer.deletedItem.desc') }}
        </p>
        <div class="tbl_header">
          <table class="tbl">
            <caption hidden>{ group name }</caption>
            <colgroup>
              <col style="width:85px">
              <col style="width:*">
            </colgroup>
            <thead>
              <tr>
                <th class="txt-left">
                  <span class="inner_item">{{ $t('common.table.header.step') }}</span>
                </th>
                <th class="txt-left">
                  <span class="inner_item">{{ $t('common.table.header.page') }}</span>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="tbl_content">
          <table class="tbl">
            <caption hidden>{ group name }</caption>
            <colgroup>
              <col style="width:85px">
              <col style="width:*">
            </colgroup>
            <tbody>
              <tr v-for="item in deletedItems" :key="item.step">
                <td class="txt-left">
                  <span class="inner_item">Step {{ item.step }}</span>
                </td>
                <td class="txt-left">
                  <span class="inner_item">{{ item.name }} ({{ item.url }})</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="wrap_btn">
          <button type="button" class="btn_modal" @click="$emit('onCloseClick')">
            {{ $t('common.ok') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sum, getUrlWithoutProtocol, getPercentage } from '@/libs/utils'
import { removeWww } from '@/libs/apply-helper'

export default {
  name: 'FunnelsLayer',
  props: [
    'flowData',
    'deletedItems'
  ],
  data () {
    return {
      items: []
    }
  },
  computed: {
    refererTotal () {
      return sum(this.flowData.refer, 'count')
    },
    conversionTotal () {
      return sum(this.flowData.cvr, 'count') + this.flowData.dropped
    },
    referers () {
      return this.getItems('referer')
    },
    conversions () {
      return this.getItems('conversion')
    },
    hasReferers () {
      return !!this.referers.length
    },
    hasConversions () {
      return !!this.conversions.length
    },
    droppedPercentage () {
      return getPercentage(this.flowData.dropped, this.conversionTotal)
    }
  },
  methods: {
    getItems (itemType) {
      let items
      let total
      let targetStep = this.flowData.funnel.step

      switch (itemType) {
        case 'referer':
          items = this.flowData.refer
          total = this.refererTotal
          targetStep--
          break
        case 'conversion':
          items = this.flowData.cvr
          total = this.conversionTotal
          targetStep++
          break
      }

      const stepDataWithoutWww = {}

      for (const [url, data] of Object.entries(this.flowData.stepData)) {
        stepDataWithoutWww[removeWww(url)] = data
      }

      return items
        .filter(item => {
          return !(item.url === 'etc' && item.count === 0)
        })
        .map((item, index) => {
          let stepUrl = getUrlWithoutProtocol(item.url)

          if (stepUrl.indexOf('/') === 0) {
            stepUrl = `${this.flowData.domain}${stepUrl}`
          }

          const stepData = stepDataWithoutWww[stepUrl]
          const isOn = stepData && stepData.step === targetStep
          const cssClass = {
            on: isOn
          }
          cssClass[`item${index + 1}`] = true

          return {
            ...item,
            isOn,
            stepData,
            cssClass,
            percentage: getPercentage(item.count, total)
          }
        })
    },
    getRefererPercentage (item) {
      return getPercentage(item.count, this.refererTotal)
    },
    getConversionPercentage (item) {
      return getPercentage(item.count, this.conversionTotal)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
}
.popup__content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1170px;
  height: 585px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding-top: 30px;
  padding-bottom: 40px;
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
  overflow: hidden;

  .btn__close {
    padding: 15px;
    position: absolute;
    top: 0;
    right: 0;
    i {
      pointer-events: none;
      background-position: center;
    }
  }
  .tit_uesr {
    display: inline-block;
    font-size: 15px;
    color: #2f2f2f;
  }
  .txt_pv {
    display: inline-block;
    font-size: 12px;
    color: #444;
  }
  .tit_uesr + .txt_pv {
    padding-left: 20px;
  }
}
.funnels__flow--wrap {
  position: relative;
  height: 100%;

  .txt_info {
    position: relative;
    display: block;
    text-align: left;
    .icon--session {
      display: inline-block;
      vertical-align: top;
    }
    .text {
      display: block;
      text-align: center;
    }
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 83px;
      width: 197px;
      border: dashed 1px #d7d7d7;
    }

    &.right {
      text-align: right;
      &:after {
        content: none;
      }
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 81px;
        width: 197px;
        border: dashed 1px #d7d7d7;
      }
      .text {
        margin-right: 5px;
        text-align: right;
      }
    }
    .right__flow--wrap {
      right: 136px;
      top: 233px;
      .txt_info {
        text-align: right;
        &:after {
          content: none;
        }
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          right: 81px;
          width: 197px;
          border: dashed 1px #d7d7d7;
        }
        .text {
          margin-right: 5px;
          text-align: right;
        }
      }
    }
  }
  .left__flow--wrap {
    position: absolute;
    left: 0;
    top: 40px;
    &.empty {
      top: 233px;
      left: 136px;
    }
  }
  .list_flow {
    position: relative;
    .item {
      position: absolute;
      left: 0;
      width: 325px;
      height: 60px;
      border-radius: 30px;
      box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.08);
      border: solid 2px #c1c1c1;
      background-color: #ffffff;
      box-sizing: border-box;
      .bar--wrap {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 30px;
        .bar_bg {
          display: block;
          height: 100%;
          border-radius: 30px 0 0 30px;
          opacity: 0.25;
          background-color: #c1c1c1;
        }
      }
      .value_wrap {
        position: relative;
        margin: 8px 0 0 25px;
        font-size: 14px;
        .flow_txt {
          display: block;
          margin-right: 20px;
          color: #444;
          font-weight: bold;
          line-height: 17px;
          .txt_desc {
            color: #289eef;
          }
        }
        .flow_num {
          display: block;
          margin-top: 4px;
          font-size: 13px;
        }
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: -101px;
      }
    }
    .item.on {
      background-color: #fff;
      border: solid 3px #289eef;
      box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.08);
      .bar_bg {
        background-color: #289eef;
        opacity: 0.15;
      }
    }
    .item1 {
      top: 0;
      &:after {
        content: "";
        width: 100px;
        height: 197px;
        background: url(../../assets/img/funnel/inflow_left_line1.svg) no-repeat;
      }
    }
    .item1.on {
      &:after {
        right: -106px;
        width: 106px;
        height: 203px;
        background: url(../../assets/img/funnel/inflow_left_line1on.svg)
          no-repeat;
      }
    }
    .item2 {
      top: 80px;
      &:after {
        content: "";
        width: 100px;
        height: 119px;
        background: url(../../assets/img/funnel/inflow_left_line2.svg) no-repeat;
      }
    }
    .item2.on {
      &:after {
        right: -106px;
        width: 106px;
        height: 203px;
        background: url(../../assets/img/funnel/inflow_left_line2on.svg)
          no-repeat;
      }
    }
    .item3 {
      top: 160px;
      &:after {
        content: "";
        width: 99px;
        height: 41px;
        background: url(../../assets/img/funnel/inflow_left_line3.svg) no-repeat;
      }
    }
    .item3.on {
      &:after {
        right: -105px;
        width: 105px;
        height: 47px;
        background: url(../../assets/img/funnel/inflow_left_line3on.svg)
          no-repeat;
      }
    }
    .item4 {
      top: 240px;
      &:after {
        content: "";
        top: -11px;
        width: 99px;
        height: 41px;
        background: url(../../assets/img/funnel/inflow_left_line4.svg) no-repeat;
      }
    }
    .item4.on {
      &:after {
        right: -105px;
        top: -15px;
        width: 105px;
        height: 47px;
        background: url(../../assets/img/funnel/inflow_left_line4on.svg)
          no-repeat;
      }
    }
    .item5 {
      top: 320px;
      &:after {
        content: "";
        top: -89px;
        width: 100px;
        height: 119px;
        background: url(../../assets/img/funnel/inflow_left_line5.svg) no-repeat;
      }
    }
    .item5.on {
      &:after {
        right: -105px;
        top: -94px;
        width: 106px;
        height: 125px;
        background: url(../../assets/img/funnel/inflow_left_line5on.svg)
          no-repeat;
      }
    }
    .item6 {
      top: 400px;
      &:after {
        content: "";
        top: -168px;
        width: 100px;
        height: 197px;
        background: url(../../assets/img/funnel/inflow_left_line6.svg) no-repeat;
      }
    }
    .item6.on {
      &:after {
        right: -102px;
        top: -167px;
        width: 101px;
        height: 199px;
        background: url(../../assets/img/funnel/inflow_left_line6on.svg)
          no-repeat;
      }
    }
  }
  .page__info--wrap {
    position: absolute;
    top: calc(50% - 6px);
    left: calc(50% - 6px);
    width: 248px;
    height: 88px;
    margin: -44px 0 0 -124px;
    padding: 18px 0;
    border-radius: 65px;
    border: solid 3px #289eef;
    background-color: rgba(40, 158, 239, 0.15);
    box-shadow: 0 15px 12px -7px rgba(0, 0, 0, 0.3);
    text-align: center;
    .page_tit {
      display: block;
      font-size: 15px;
      color: #289eef;
    }
    .page_info {
      display: block;
      margin-top: 5px;
      font-size: 15px;
      padding: 0 20px;
      line-height: 1.2;
    }
    .page_url {
      display: block;
      margin-top: 13px;
      padding: 0 10px;
      white-space: nowrap;
      line-height: 1.2;
    }
    .page_tag {
      display: inline-block;
      height: 16px;
      margin-top: 11px;
      font-size: 12px;
      line-height: 12px;
      font-weight: 500;
      border-radius: 4px;
      padding: 2px 5px 0 5px;
      color: #fff;
      box-sizing: border-box;
      background-color: #8d8d8d;
    }
  }
  .right__flow--wrap {
    position: absolute;
    right: 325px;
    top: 40px;
    &.empty {
      right: 136px;
      top: 233px;
    }
    .list_flow {
      .item {
        &:after {
          content: none;
        }
        &:last-child {
          width: 280px;
          padding-left: 67px;
          border: 2px solid #ff8400;
          background-color: #ff8400;
          .value_wrap {
            margin: 13px 0 0 0;
            color: #fff;
            .flow_txt {
              color: #fff;
            }
          }
          &:before {
            content: "";
            position: absolute;
            top: -168px;
            left: -109px;
            width: 97px;
            height: 202px;
            background: url(../../assets/img/funnel/exit_arrow_line.svg)
              no-repeat;
          }
          &:after {
            content: "";
            position: absolute;
            top: 13px;
            left: 20px;
            width: 25px;
            height: 32px;
            background: url(../../assets/img/funnel/inflow_exit_arrow.svg)
              no-repeat;
          }
        }
      }
      .item1 {
        &:before {
          content: "";
          position: absolute;
          top: calc(50% - 6px);
          left: -106px;
          width: 103px;
          height: 203px;
          background: url(../../assets/img/funnel/inflow_right_line1.svg)
            no-repeat;
        }
      }
      .item1.on {
        &:before {
          width: 103px;
          height: 203px;
          background: url(../../assets/img/funnel/inflow_right_line1on.svg)
            no-repeat;
        }
      }
      .item2 {
        &:before {
          content: "";
          position: absolute;
          top: calc(50% - 6px);
          left: -106px;
          width: 103px;
          height: 124px;
          background: url(../../assets/img/funnel/inflow_right_line2.svg)
            no-repeat;
        }
      }
      .item2.on {
        &:before {
          width: 103px;
          height: 125px;
          background: url(../../assets/img/funnel/inflow_right_line2on.svg)
            no-repeat;
        }
      }
      .item3 {
        &:before {
          content: "";
          position: absolute;
          top: calc(50% - 6px);
          left: -106px;
          width: 103px;
          height: 46px;
          background: url(../../assets/img/funnel/inflow_right_line3.svg)
            no-repeat;
        }
      }
      .item3.on {
        &:before {
          width: 103px;
          height: 47px;
          background: url(../../assets/img/funnel/inflow_right_line3on.svg)
            no-repeat;
        }
      }
      .item4 {
        &:before {
          content: "";
          position: absolute;
          top: -12px;
          left: -106px;
          width: 103px;
          height: 46px;
          background: url(../../assets/img/funnel/inflow_right_line4.svg)
            no-repeat;
        }
      }
      .item4.on {
        &:before {
          top: -7px;
          width: 103px;
          height: 47px;
          background: url(../../assets/img/funnel/inflow_right_line4on.svg)
            no-repeat;
        }
      }
      .item5 {
        &:before {
          content: "";
          position: absolute;
          top: -90px;
          left: -106px;
          width: 103px;
          height: 124px;
          background: url(../../assets/img/funnel/inflow_right_line5.svg)
            no-repeat;
        }
      }
      .item5.on {
        &:before {
          width: 103px;
          height: 125px;
          background: url(../../assets/img/funnel/inflow_right_line5on.svg)
            no-repeat;
        }
      }
    }
  }
}

.popup__content3 {
  width: 830px;
  height: 497px;
  padding: 50px 30px 25px 30px;
  .txt_desc {
    font-size: 20px;
    color: #444;
    text-align: center;
    line-height: 26px;
    .icon--alert {
      margin: 0 auto;
      margin-bottom: 12px;
      display: block;
    }
  }
}
.txt_desc + .tbl_header {
  margin-top: 25px;
}
.tbl_header {
  position: relative;
  padding: 0 5px;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 40px;
    border-radius: 5px 0 0 5px;
    background-color: #555;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 5px;
    height: 40px;
    border-radius: 0 5px 5px 0;
    background-color: #555;
  }
}
.tbl {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  .txt-left {
    text-align: left;
  }
  thead {
    tr {
      background-color: #555;
    }
    th {
      height: 40px;
      color: #fff;
      .inner_item {
        position: relative;
        padding-left: 14px;
        line-height: 16px;
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #ebebeb;
      td {
        height: 60px;
        line-height: 14px;
        text-align: center;
        .inner_item {
          padding-left: 4px;
          line-height: 14px;
        }
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
.tbl_content {
  overflow: hidden;
  overflow-y: auto;
  max-height: 182px;
  padding-left: 10px;
  border-bottom: 1px solid #ebebeb;
}
.wrap_btn {
  width: 100%;
  margin-top: 25px;
  .btn_modal {
    margin: 0 auto;
    display: block;
    min-width: 84px;
    padding: 0 10px;
    line-height: 36px;
    border-radius: 20px;
    border: solid 1px #bbb;
    background-color: #fff;
    font-size: 13px;
    color: #444;
  }
}
</style>
